import Swiper, { Navigation, Lazy } from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class EditorialCarousel extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-editorialCarousel',
      prevArrow: '.js-editorialCarouselPrev',
      nextArrow: '.js-editorialCarouselNext',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$get(this.refs.prevArrow),
      $nextArrow: this.$get(this.refs.nextArrow),
    };

    this.state = {
      swiper: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation, Lazy],
      preloadImages: false,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: false,
      loop: true,
      navigation: {
        prevEl: dom.$prevArrow,
        nextEl: dom.$nextArrow,
      },
      lazy: {
        loadOnTransitionStart: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 50,
          centeredSlides: true,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 70,
          centeredSlides: true,
        },
        1440: {
          slidesPerView: 2,
          spaceBetween: 100,
          centeredSlides: true,
        },
      },
    });
  }
}
